import { ExistsElement, SetContentToElement } from './util';

import { SetAttr, GetElement } from '@/libs/util';

type Show = (
  existsElement: ExistsElement,
  setContentToElement: SetContentToElement,
  getElement: GetElement,
  setAttr: SetAttr,
  updateWcContent: UpdateWcContent,
  selector: string,
  wcSelector: string,
  excludeAttr: string,
  includeAttr: string
) => (excludeTaxText: string | undefined, includeTaxText: string) => void;

export type UpdateWcContent = (
  setAttr: SetAttr,
  element: Element,
  excludeAttr: string,
  includeAttr: string,
  excludeTaxText: string,
  includeTaxText: string
) => void;

/**
 * 要素の表示を行う
 * @param existsElement 要素が存在するか確認する関数
 * @param setContentToElement 要素にコンテンツをセットする関数
 * @param getElement 要素を取得する関数
 * @param setAttr 属性を設定する関数
 * @param updateWcContent wc要素を更新する関数
 * @param selector セレクター
 * @param wcSelector wcのセレクター
 * @param excludeAttr 税抜き属性名
 * @param includeAttr 税込み属性名
 */
export const show: Show = (
  existsElement,
  setContentToElement,
  getElement,
  setAttr,
  updateWcContent,
  selector,
  wcSelector,
  excludeAttr,
  includeAttr
) => (excludeTaxText, includeTaxText) => {
  const element = getElement(wcSelector);
  if (element && excludeTaxText) {
    updateWcContent(
      setAttr,
      element,
      excludeAttr,
      includeAttr,
      excludeTaxText,
      includeTaxText
    );
  }
  if (!existsElement(selector) || !excludeTaxText) return;
  setContentToElement(selector, excludeTaxText);
};

/**
 * wc要素の属性を設定する
 *
 * @param setAttr 属性を設定する関数
 * @param element wc要素
 * @param excludeAttr 税抜き属性名
 * @param includeAttr 税込み属性名
 * @param excludeTaxText 税抜きテキスト
 * @param includeTaxText 税込みテキスト
 */
export const updateWcContent: UpdateWcContent = (
  setAttr,
  element,
  excludeAttr,
  includeAttr,
  excludeTaxText,
  includeTaxText
) => {
  if (includeTaxText) {
    setAttr(element, excludeAttr, excludeTaxText.replace(/[^0-9]/g, ''));
    setAttr(element, includeAttr, includeTaxText.replace(/[^0-9]/g, ''));
  } else {
    setAttr(element, excludeAttr, excludeTaxText.replace(/[^0-9\-]/g, ''));
  }
};
